import { TaxIntentOptions } from '../../enums';
import { GenericCheckboxStep } from './GenericCheckboxStep';

function IntentStep() {
  return (
    <GenericCheckboxStep
      title="How can a tax pro best support you?"
      subtitle="Select all that apply."
      checkboxOptions={TaxIntentOptions}
      referralFieldName="tax_intents"
      stepName="intent_step"
    />
  );
}

export { IntentStep };
